
import {Component, Vue} from 'vue-property-decorator';
import Pagination from "@/components/Pagination/index.vue";
import {getDeclarationInvoiceAmountDetail, getInvoiceAmountDetail} from "@/api/invoice/index";

@Component({
  name: 'InvoiceAmountDetail',
  components: {Pagination}
})
export default class InvoiceAmountDetail extends Vue {

  public showDialog = false;
  public loading = false;
  private list = [
    {
      label: "开票总金额",
      prop: "invoiceAmount",
      key: "invoiceAmount",
    },
    {
      label: "开票货款合计",
      prop: "productAmount",
      key: "productAmount"
    },
    {
      label: "额外费用合计",
      prop: "deductionAndFilling",
      key: "deductionAndFilling"
    },
    {
      label: "其他费用合计",
      prop: "otherAmount",
      key: "otherAmount",
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
    },
  ];
  private readForm = {
    invoiceAmount: "",
    productAmount: "",
    deductionAndFilling: "",
    otherAmount: "",
    remark: ""
  }
  private tableCol = [
    {
      label: "装箱单号",
      prop: "code",
      key: "code",
    },
    {
      label: "开票货款",
      prop: "amount",
      key: "amount",
    },
    {
      label: "补款",
      prop: "fill",
      key: "fill",
      type: "custom",
      slot: "fill0"
    },
    {
      label: "扣款",
      prop: "deduction",
      key: "deduction",
      type: "custom",
      slot: "deduction0"
    },
    {
      label: "索赔",
      prop: "claim",
      key: "claim",
      type: "custom",
      slot: "claim0"
    },
    {
      label: "备注",
      prop: "remark",
      key: "remark",
    },
  ]
  private table = {
    list: [] as any[],
  };
  private id = "";
  private type = "FACTORY_INVOICE";

  private async getList() {
    this.loading = true;
    try {
      let res;
      if (this.type == "FACTORY_INVOICE") {
        res = await getInvoiceAmountDetail({id: this.id})
      } else {
        res = await getDeclarationInvoiceAmountDetail({id: this.id})
      }
      this.readForm = {
        invoiceAmount: res.totalAmount,
        productAmount: res.productAmount,
        deductionAndFilling: res.deductionAndFilling,
        otherAmount: res.otherAmount,
        remark: res.remark
      }
      const extra = res.extraSettlements.reduce((acc, item) => {
        // 按 code 分组
        if (!acc[item.code]) {
          acc[item.code] = {};
        }

        // 按 type 分组
        if (!acc[item.code][item.type]) {
          acc[item.code][item.type] = [];
        }
        if (item.type == "索赔") {
          acc[item.code][item.type].push(`${item.claimCode || ""}    ${item.amount}`);
        }else {
          acc[item.code][item.type].push(`${item.moneyType?.desc}:${item.amount}    ${item.remark || ""}`);
        }
        return acc;
      }, {});
      this.table.list = res.summaryList.map(item => {
        if (extra[item.code]?.['补款']) {
          item.fillExtra = extra[item.code]?.['补款'];
        }
        if (extra[item.code]?.['扣款']) {
          item.deductionExtra = extra[item.code]?.['扣款'];
        }
        if (extra[item.code]?.['索赔']) {
          item.claimExtra = extra[item.code]?.['索赔'];
        }
        return item;
      });
    } finally {
      this.loading = false;
    }
  }

  public async openDialog(obj) {
    this.showDialog = true;
    this.id = obj.id;
    this.type = obj.type;
    this.getList()
  }
}
